import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LayoutUserHeader from '../components/LayoutUserHeader';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const Unit = () => {
  const [units, setUnits] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [unitName, setUnitName] = useState('');
  const [selected, setSelected] = useState(null);

  const fetchUnits = async () => {
    try {
      // const res = await axios.get(`${BASE_URL}/Unit/GetAllUnits`);
      const gstNumber = localStorage.getItem('gstNumber');
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Unit/GetUnitBasedOnGST`, {
  params: { gstNumber },
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

      const data = res.data.data || [];
      setUnits(data);
      setFilteredUnits(data);
    } catch (err) {
      console.error('Fetch units failed:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase();
    setSearch(value);
    setFilteredUnits(units.filter(u => u.UnitName.toUpperCase().includes(value)));
  };

  const handleAdd = () => {
    setSelected(null);
    setUnitName('');
    setOpen(true);
  };

  const handleEdit = (row) => {
    setSelected(row);
    setUnitName(row.UnitName);
    setOpen(true);
  };

  const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this unit?")) return;

  try {
    const token = localStorage.getItem("token");

    await axios.delete(`${BASE_URL}/Unit/DeleteUnit/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    toast.success("Unit deleted successfully");
    fetchUnits();
  } catch (err) {
    toast.error("Delete failed");
  }
};

  const handleSave = async () => {
    try {
       const token = localStorage.getItem("token");

      const payload = {
        UnitName: unitName.trim(),
        gstNumber: localStorage.getItem('gstNumber')
      };

      if (selected) {
       await axios.put(`${BASE_URL}/Unit/UpdateUnit/${selected.id}`, payload, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

        toast.success("Unit updated successfully");
      } else {
        await axios.post(`${BASE_URL}/Unit/AddUnit`, payload, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
        toast.success("Unit added successfully");
      }

      setOpen(false);
      fetchUnits();
    } catch (err) {
      const message = err?.response?.data?.message || 'Save failed';
      toast.error(message);
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'UnitName', headerName: 'Unit Name', flex: 2 },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button variant="outlined" color="primary" size="small" onClick={() => handleEdit(params.row)}>
            Edit
          </Button>
          <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(params.row.id)} style={{ marginLeft: 8 }}>
            Delete
          </Button>
        </>
      )
    }
  ];

  return (
    <>
      <LayoutUserHeader />
      <ToastContainer position="top-right" autoClose={3000} />
      <Box p={2}>
        <Typography variant="h5" gutterBottom>Unit List</Typography>
        <Box display="flex" justifyContent="space-between" mb={2}>
          <TextField label="Search" value={search} onChange={handleSearch} />
          <Button variant="contained" color="primary" onClick={handleAdd}>Add Unit</Button>
        </Box>
        <DataGrid
          autoHeight
          rows={filteredUnits}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
          loading={loading}
          disableSelectionOnClick
          sortingOrder={['asc', 'desc']}
        />

        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>{selected ? 'Edit Unit' : 'Add Unit'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Unit Name"
              fullWidth
              value={unitName}
              onChange={(e) => setUnitName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave}>
              {selected ? 'Update' : 'Add'}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default Unit;











// import React, { useState, useEffect } from 'react';
// import {
//   TextField, Button, Box, Typography, Dialog, DialogTitle, DialogContent, DialogActions
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import axios from 'axios';
// import LayoutAdminHeader from '../components/LayoutAdminHeader';

// const BASE_URL = process.env.REACT_APP_BASE_URL || '';

// const Unit = () => {
//   const [units, setUnits] = useState([]);
//   const [filteredUnits, setFilteredUnits] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [open, setOpen] = useState(false);
//   const [unitName, setUnitName] = useState('');
//   const [selected, setSelected] = useState(null);

//   const fetchUnits = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/Unit/GetAllUnits`);
//       const data = res.data.data || [];
//       setUnits(data);
//       setFilteredUnits(data);
//     } catch (err) {
//       console.error('Fetch units failed:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchUnits();
//   }, []);

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearch(value);
//     setFilteredUnits(units.filter(u => u.UnitName.toLowerCase().includes(value)));
//   };

//   const handleAdd = () => {
//     setSelected(null);
//     setUnitName('');
//     setOpen(true);
//   };

//   const handleEdit = (row) => {
//     setSelected(row);
//     setUnitName(row.UnitName);
//     setOpen(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this unit?')) return;
//     try {
//       await axios.delete(`${BASE_URL}/Unit/DeleteUnit/${id}`);
//       fetchUnits();
//     } catch (err) {
//       alert('Delete failed');
//     }
//   };

//   const handleSave = async () => {
//     try {
//       if (selected) {
//         await axios.put(`${BASE_URL}/Unit/UpdateUnit/${selected.id}`, { UnitName: unitName });
//       } else {
//         await axios.post(`${BASE_URL}/Unit/AddUnit`, { UnitName: unitName });
//       }
//       setOpen(false);
//       fetchUnits();
//     } catch (err) {
//       alert('Save failed');
//     }
//   };

//   const columns = [
//     { field: 'id', headerName: 'ID', flex: 1 },
//     { field: 'UnitName', headerName: 'Unit Name', flex: 2 },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       flex: 1,
//       sortable: false,
//       renderCell: (params) => (
//         <>
//           <Button variant="outlined" color="primary" size="small" onClick={() => handleEdit(params.row)}>
//             Edit
//           </Button>
//           <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(params.row.id)} style={{ marginLeft: 8 }}>
//             Delete
//           </Button>
//         </>
//       )
//     }
//   ];

//   return (
//     <>
//     <LayoutAdminHeader />
//     <Box p={2}>
//       <Typography variant="h5" gutterBottom>Unit List</Typography>
//       <Box display="flex" justifyContent="space-between" mb={2}>
//         <TextField label="Search" value={search} onChange={handleSearch} />
//         <Button variant="contained" color="primary" onClick={handleAdd}>Add Unit</Button>
//       </Box>
//       <DataGrid
//         autoHeight
//         rows={filteredUnits}
//         columns={columns}
//         pageSize={5}
//         rowsPerPageOptions={[5, 10]}
//         loading={loading}
//         disableSelectionOnClick
//         sortingOrder={['asc', 'desc']}
//       />

//       <Dialog open={open} onClose={() => setOpen(false)}>
//         <DialogTitle>{selected ? 'Edit Unit' : 'Add Unit'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Unit Name"
//             fullWidth
//             value={unitName}
//             onChange={(e) => setUnitName(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>Cancel</Button>
//           <Button variant="contained" onClick={handleSave}>
//             {selected ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//     </>
//   );
// };

// export default Unit;
